import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 px-5 pb-16 pt-16 sm:px-8 sm:pb-24 sm:pt-24" data-id="element-145" data-mp="ehtk3yp8h5ov">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[-18rem] h-[36rem] w-[36rem] -translate-x-1/2 rounded-full bg-accent/20 blur-[140px]" data-id="element-146" data-mp="4lqictyan92g" />
      <div className="relative mx-auto grid w-full max-w-6xl items-center gap-12 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-147" data-mp="128pi5dka8x4k">
        <motion.div initial={{
        opacity: 0,
        y: 28
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-148" data-mp="x8b6lljh351s">
          <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs font-medium text-white/70 sm:text-sm" data-id="element-149" data-mp="neklmqmk1cqu">
            <SparklesIcon className="h-4 w-4 text-accent-soft" aria-hidden="true" data-id="element-150" data-mp="380vy3velgpc3" />
            Atención si tienes un iPhone y sientes que no lo estás aprovechando
            al máximo...
          </p>

          <h1 className="text-[2rem] font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-[3.4rem]" data-id="element-151" data-mp="3o73og9djvq70">
            Compraste tu iPhone, pagaste mucho dinero por él...{' '}
            <span className="text-accent-soft" data-id="element-152" data-mp="3e7uwtn65qnnt">
              y todavía no sabes cómo usarlo de verdad.
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-153" data-mp="30g6oluz14jc4">
            Descubre el método paso a paso para dominar tu iPhone desde cero,
            activar funciones ocultas, mejorar tu batería, proteger tus datos,
            organizar tu celular y usarlo como un profesional, aunque no sepas
            nada de tecnología.
          </p>

          <div className="mt-10 flex justify-start" data-id="element-154" data-mp="2hjynn3d1uumm">
            <CTAButton note="Acceso inmediato después de tu compra. Sin esperas." data-id="element-155" data-mp="2ll0eowwtc0di" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-full max-w-sm" data-id="element-156" data-mp="s2tenov66frb">
          
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto mt-14 w-full max-w-2xl" data-id="element-157" data-mp="deyh9v67vn7w">
        <img src="https://cdn.magicpatterns.com/uploads/t4AKBSPk9J146ZgvKMMEjG/ChatGPT_Image_27_jul_2026,_05_38_36_p.m..png" alt="Diccionario Apple: todo Apple en un solo lugar, con explicaciones claras, búsqueda rápida, funciones esenciales y para todos los niveles" className="w-full rounded-3xl border border-white/10 object-cover" data-id="element-158" data-mp="111y8wizp7mxo" />
      </motion.div>
    </header>;
}